import { useNavigate } from 'react-router-dom';
import { authHelpers } from '../api/docenteApi';
import { mensajePeriodoDocente } from '../utils/periodoEscolar';

export default function AvisoPeriodoDocente({ periodoSesion, periodoHorario }) {
  const navigate = useNavigate();
  const mensaje = mensajePeriodoDocente(periodoSesion, periodoHorario);
  if (!mensaje) return null;
  const volverAIngresar = () => {
    authHelpers.limpiarSesion();
    navigate('/login');
  };
  return <div role="status" className="space-y-4">
    <h3 className="text-xl font-bold">Actualiza tu sesión docente</h3>
    <p className="text-base-content/70 text-sm">{mensaje}</p>
    <button type="button" className="btn btn-primary btn-sm" onClick={volverAIngresar}>Volver a ingresar</button>
  </div>;
}
